import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import Text from "~/components-shared/Text";
import { Break, Button, Icon, InputText, Link, Modal, Spinner } from "~/components-shared";
import WorkingStyleChartCard from "~/components/WorkingStyleChartCard";
import { useDispatch, useSelector } from "react-redux";
import { CRUDActionEnum, StatusStateEnum } from "~/types/enums";
import workingStyleSelectors from "~/store/workingStyles/selectors";
import workingStylesActionCreators from "~/store/workingStyles/actions";
import WorkingStyleEmailSignatureModal from "~/components/WorkingStyleEmailSignatureModal";
import ai from "~/assets/i/logos/ai.png";
import Picture from "~/components-shared/Picture";
const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
`;
const Summary = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;
const StyledPicture = styled(Picture)`
  position: absolute;
  top: 0;
  left: -1.7rem;
`;
const WorkingStyleSideBar = _ref => {
  let {
    workingStyleId
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const workingStyle = useSelector(workingStyleId ? workingStyleSelectors.getWorkingStyle(workingStyleId) : workingStyleSelectors.getMyWorkingStyle);
  const status = useSelector(workingStyleId ? workingStyleSelectors.getStatusByWorkingStyle(workingStyleId) : workingStyleSelectors.getMyStatus);
  const [emailSignatureOpen, setEmailSignatureOpen] = useState(false);
  if (!workingStyle && status === StatusStateEnum.FAILED) {
    return null;
  }
  if (!workingStyle) {
    return /*#__PURE__*/React.createElement(Spinner, {
      center: true
    });
  }
  const handleInvite = () => {
    dispatch(workingStylesActionCreators.actionChanged(CRUDActionEnum.INVITE, undefined));
  };
  const handleShare = () => {
    dispatch(workingStylesActionCreators.actionChanged(CRUDActionEnum.SHARE, workingStyle.id));
  };
  const handleEmailSignature = () => {
    setEmailSignatureOpen(true);
  };
  const handleLeaveFeedback = () => {
    dispatch(workingStylesActionCreators.actionChanged(CRUDActionEnum.FEEDBACK, workingStyle.id));
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 3
    }
  }, t("PublicWorkingStyleSideBar.weLoveFeedback")), /*#__PURE__*/React.createElement(Link, {
    color: "grey",
    underline: true,
    onClick: handleLeaveFeedback,
    s: {
      mb: 6
    },
    fontSize: 3.5
  }, t("PublicWorkingStyleSideBar.howToImprove")), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 4,
    s: {
      mb: 3
    },
    style: {
      width: "100%"
    }
  }, t("WorkingStyleSideBar.savedWithEmail")), /*#__PURE__*/React.createElement(InputText, {
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      s: {
        mr: 2
      },
      src: "mail",
      color: colors.text.secondary
    }),
    value: workingStyle.email,
    s: {
      mb: 5
    },
    disabled: true
  })), workingStyle.summary && /*#__PURE__*/React.createElement(Summary, null, /*#__PURE__*/React.createElement(StyledPicture, {
    src: ai,
    s: {
      mr: 1
    },
    width: "1.3rem",
    height: "1.3rem"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, workingStyle.summary)), /*#__PURE__*/React.createElement(WorkingStyleChartCard, {
    email: workingStyle.email,
    style: {
      width: "100%"
    }
  }), /*#__PURE__*/React.createElement(Break, {
    s: {
      my: 5
    }
  }, t("common.actions.actions")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: handleShare,
    maxWidth: "230px",
    s: {
      mb: 4
    },
    fullWidth: true
  }, t("WorkingStyleSideBar.shareProfile")), /*#__PURE__*/React.createElement(Button, {
    color: "primaryGrey",
    onClick: handleEmailSignature,
    maxWidth: "230px",
    s: {
      mb: 3
    },
    fullWidth: true
  }, t("PublicWorkingStyleSideBar.emailSignature")), /*#__PURE__*/React.createElement(Link, {
    color: colors.text.secondary,
    onClick: handleInvite,
    underline: true
  }, t("WorkingStyleSideBar.inviteOthers")), /*#__PURE__*/React.createElement(Modal, {
    open: emailSignatureOpen
  }, /*#__PURE__*/React.createElement(WorkingStyleEmailSignatureModal, {
    workingStyle: workingStyle,
    onClose: () => setEmailSignatureOpen(false)
  })));
};
export default WorkingStyleSideBar;